module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/amnesty-d6174c0488b43fc541f04a39688b8578.png";